<div class="loader-wrap" [ngClass]="{show: loading.length}">
	<div class="loader-spinner" [ngClass]="{show: loading.length}">
		<div></div>
		<div></div>
	</div>
</div>
